import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { consentCancelModalData } from '../../data/modalContentData'
import SearchResultHint from '../../components/SearchResultHint'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import Headings from '../../components/Headings'
import SearchBar from '../../components/SearchBar'
import Radio from '../../components/Radio'
import radioData from '../../data/radioData'
import DirectionLink from '../../components/DirectionLink'
import PageModal from '../../components/PageModal'
import PageFooter from '../../components/PageFooter'

const Provider = () => {
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)
  const [radioDataSet, setRadioDataSet] = useState(null)
  const [filterData, setFilterData] = useState(null)
  const [isSearchResult, setIsSearchResult] = useState(false)
  const [isProviderSelected, setIsProviderSelected] = useState(null)
  const [navModalBtnFocused, setNavModalBtnFocused] = useState(false)

  // reset the focus rules when the page rerender
  useEffect(() => {
    if (navModalBtnFocused) {
      setNavModalBtnFocused(false)
    }
    if (radioDataSet) {
      setRadioDataSet(radioDataSet)
    }
  }, [navModalBtnFocused, radioDataSet])
  function closeModal() {
    setOpenModal(false)
    setNavModalBtnFocused(true)
  }

  // initialize the radio data set with chek status and on change func,
  const radioDataWithFunc = radioData.map((item, index) => ({
    ...item,
    isRadioChecked: false,
    isDisplay: true,
    onChangeFunc: (text) => () => selectProvider(text),
  }))
  // if (radioDataSet === null) {
  //   setRadioDataSet(radioDataWithFunc)
  // }

  // select the checked provider and then rerender the item checked status
  function selectProvider(providerText) {
    setRadioDataSet(
      radioDataWithFunc.map((item, index) => {
        if (providerText === item.text) {
          return { ...item, isRadioChecked: true }
        } else {
          return { ...item, isRadioChecked: false }
        }
      })
    )
    setIsProviderSelected(true)
  }
  function selectFilterProvider(providerText) {
    setRadioDataSet(
      radioDataWithFunc.map((item, index) => {
        if (providerText === item.text) {
          return { ...item, isRadioChecked: true, isDisplay: true }
        } else {
          return { ...item, isRadioChecked: false, isDisplay: false }
        }
      })
    )
    setIsProviderSelected(true)
  }

  const handleSearch = (value) => {
    if (value) {
      setIsSearchResult(true)
      const searchRadioData = radioDataWithFunc.map((item, index) => {
        if (item.text.includes(value)) {
          return {
            ...item,
            isDisplay: true,
            onChangeFunc: (text) => () => selectFilterProvider(text),
          }
        } else {
          return {
            ...item,
            isDisplay: false,
            onChangeFunc: (text) => () => selectFilterProvider(text),
          }
        }
      })
      setFilterData(searchRadioData.filter((item) => item.isDisplay))
      setRadioDataSet(searchRadioData)
    } else {
      setIsSearchResult(false)
      setRadioDataSet(radioDataWithFunc)
    }
    setIsProviderSelected(false)
  }

  const pageModalData = {
    isOpen: openModal,
    onClose: () => closeModal(),
    data: {
      ...consentCancelModalData,
      leftButton: 'No',
      leftButtonFunc: () => closeModal(),
      rightButton: 'Yes',
      rightButtonFunc: () => navigate('/cancel-alert'),
      isModalBtn: false,
    },
  }
  const pageFooterData = {
    leftButton: 'Cancel',
    leftButtonFunc: () => setOpenModal(!openModal),
    navModalBtnFocused: navModalBtnFocused,
    rightButton: 'Continue',
    rightButtonFunc: () => navigate('/your-data'),
    isRightButtonDisabled: !isProviderSelected,
    haveShadow: true,
    leftButtonLabel:
      'cancel button, to open the cancel process modal double click here',
    rightButtonLabel: isProviderSelected
      ? 'continue button, to visit next page double click here'
      : 'continue button Disabled, please select one of your providers',
  }

  return (
    <PageWrapper isModalOpen={pageModalData.isOpen}>
      <Helmet>
        <title>Who is your provider</title>
      </Helmet>
      <PageContentWrapper isModalOpen={pageModalData.isOpen}>
        <DirectionLink
          direction="left"
          link="/procedure"
          text="Back"
          isDepenednt={true}
          isFocused={true}
          description="Back button, to visit previous page double click here."
        ></DirectionLink>
        <Headings level="h1" text="Who is your provider"></Headings>
        <SearchBar onSearch={(value) => handleSearch(value)} />

        {isSearchResult && (
          <>
            <Headings level="h2" text="Search results: "></Headings>
            <SearchResultHint
              content={`Search results: ${
                filterData && filterData.length
              } item return. Item list: ${
                filterData &&
                filterData.reduce((acc, item) => {
                  return acc + item.text
                }, '')
              }`}
            />
          </>
        )}
        <Radio data={radioDataSet || radioDataWithFunc} />
      </PageContentWrapper>
      <PageFooter {...pageFooterData} />
      <PageModal {...pageModalData} />
    </PageWrapper>
  )
}

export default Provider
